export class CountryModel {
    constructor(public name: string, public checked?: boolean) {
        if (checked === undefined) {
            this.checked = false;
        }
    }
}
